import { anyNonNil } from 'is-uuid';
import {
  MarketplacePayloadBuilder,
  ENTITY_TYPES,
  PRODUCT_TYPES,
} from '@nerdwallet/nw-api-sdk/marketplace';
import { getLogger } from '@nerdwallet/logging';

import log from '../log';
import { formatInvestingProducts } from './helpers';
import { marketplaceSDK } from '../nw-api-sdk';

const logger = getLogger('investing', log);

export const fetchBrokerages = ({
  ids = [],
  req,
  includeInactiveOrNonMonetizingProducts = false,
}) => {
  const filteredIds = ids.filter(Boolean);
  if (filteredIds.length === 0) {
    return Promise.resolve();
  }

  const payloadBuilder = new MarketplacePayloadBuilder();

  // we temporarily support both wp_review_slug and id as we transition between
  // the two

  // if we have a list of UUIDs, search via id
  if (anyNonNil(filteredIds[0])) {
    payloadBuilder.setQueryParams({
      field: 'offer.id',
      type: 'in',
      value: filteredIds,
    });
  }
  // otherwise, search by wp_review_slug
  else {
    payloadBuilder.setQueryParams({
      field: 'offer.details.wp_review_slug',
      type: 'in',
      value: filteredIds,
    });
  }

  if (!includeInactiveOrNonMonetizingProducts) {
    payloadBuilder.setQueryParams({
      field: 'offer.details.is_monetizing',
      type: 'eq',
      value: true,
    });
  }

  payloadBuilder.setPagination({ offset: 0, limit: filteredIds.length });

  const options = {
    entityType: ENTITY_TYPES.OFFERS,
    productType: PRODUCT_TYPES.INVESTING,
    payload: payloadBuilder.getPayload(),
    includeAdditionalData: true,
    serverRequest: req,
  };

  return (
    marketplaceSDK
      .getMarketplaceData(options)
      /* istanbul ignore next */
      .catch((e) => {
        // catch and re-throw so we can include information about which fetch is erroring
        logger.error('Error fetching investing data: ', e);
        throw new Error('Error fetching investing data - more details above');
      })
  );
};

export default function createBrokeragesProvider({
  req,
  includeInactiveOrNonMonetizingProducts,
}) {
  const loadDescription = ({ ids }) =>
    fetchBrokerages({
      ids,
      includeInactiveOrNonMonetizingProducts,
      req,
    }).then(({ data }) => formatInvestingProducts(data.offers));

  const load = (descriptions) => descriptions.map(loadDescription);

  return {
    load,
  };
}
